import { motion } from 'framer-motion';

export default function Solutions() {
  const solutions = [
    { icon: 'ri-store-2-line', title: 'Lokale Unternehmen', description: 'Mehr Kunden vor Ort gewinnen mit einer professionellen Online-Präsenz und lokaler SEO-Optimierung.' },
    { icon: 'ri-briefcase-line', title: 'Dienstleister & Berater', description: 'Vertrauen aufbauen und Anfragen steigern durch überzeugendes Webdesign und AI-gestützte Automatisierung.' },
    { icon: 'ri-shopping-cart-line', title: 'Online-Shops', description: 'Umsatz steigern mit einem schnellen, benutzerfreundlichen E-Commerce-Erlebnis und optimierter Performance.' },
    { icon: 'ri-building-line', title: 'Startups & KMU', description: 'Von Anfang an professionell auftreten, digital wachsen und mit AI-Chatbots Prozesse automatisieren.' },
  ];

  return (
    <section className="py-20 sm:py-24 bg-brand-beige-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16 sm:mb-20"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-caprasimo mb-4 sm:mb-6 text-brand-black px-4">
            Für wen ich arbeite
          </h2>
          <p className="text-lg sm:text-xl text-brand-grey max-w-3xl mx-auto px-4">
            Maßgeschneiderte Lösungen für Webdesign, AI & Automatisierung
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {solutions.map((solution, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="group relative bg-white rounded-2xl p-6 hover:shadow-2xl transition-all cursor-pointer border border-brand-beige hover:border-brand-green overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-brand-green/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              
              <div className="relative z-10">
                <div className="w-12 h-12 flex items-center justify-center bg-brand-beige-light rounded-lg mb-4 group-hover:bg-brand-green group-hover:scale-110 transition-all">
                  <i className={`${solution.icon} text-xl text-brand-green group-hover:text-white transition-colors`}></i>
                </div>
                <h3 className="text-xl font-caprasimo mb-3 text-brand-black group-hover:text-brand-green transition-colors">
                  {solution.title}
                </h3>
                <p className="text-sm text-brand-grey leading-relaxed">{solution.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}